import { useMemo } from 'react'

import { ZervantPlanTier } from '../enums/zervantPlanTier'
import { ZervantSubscriptionQuotaType } from '../enums/zervantSubscriptionQuotaType'
import { getIsPremiumInvoicesQuotaReached } from '../utils/getIsPremiumInvoicesQuotaReached'
import { useFetchZervantSubscription } from './useFetchZervantSubscription'

const PREMIUM_PLAN_TIERS = new Set<string>([ZervantPlanTier.Start, ZervantPlanTier.Plus])

const isZervantPremiumPlan = (planId: string): boolean =>
  planId.split('_').some((segment) => PREMIUM_PLAN_TIERS.has(segment.toLowerCase()))

export const useZervantSubscriptionDetails = () => {
  const { zervantSubscription, isLoading } = useFetchZervantSubscription()

  const premiumInvoicesQuota = useMemo(
    () => zervantSubscription?.quotas.find((quota) => quota.type === ZervantSubscriptionQuotaType.Invoice),
    [zervantSubscription?.quotas],
  )
  const isPremiumInvoicesQuotaReached = getIsPremiumInvoicesQuotaReached(premiumInvoicesQuota)
  const isInZervantNoPlan = !zervantSubscription || !isZervantPremiumPlan(zervantSubscription.plan?.id ?? '')

  return {
    isInZervantNoPlan,
    isLoading,
    isPremiumInvoicesQuotaReached,
  }
}
